// extracted by mini-css-extract-plugin
module.exports = {"warningContainer":"MultiPurposeInfo_warningContainer__lkt6t","warningMessage":"MultiPurposeInfo_warningMessage__3fmVU","icon":"MultiPurposeInfo_icon__3F0M1"};